import { Aggregates } from "hfapi";

class HfMember extends Aggregates.HfMember {

}

export default HfMember;
